import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/hebeidaxue/redstar.png';
const _hoisted_1 = {
  class: "pophead"
};
const _hoisted_2 = {
  class: "phleft"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "views"
};
const _hoisted_5 = {
  class: "popcontent"
};
const _hoisted_6 = {
  class: "popconleft"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "popconright"
};
const _hoisted_9 = {
  class: "innerbox"
};
const _hoisted_10 = {
  class: "imgcontent"
};
const _hoisted_11 = {
  class: "swiper-wrapper"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "textcontainer"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  class: "otherdesc"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = ["href"];
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  class: "innerbox"
};
const _hoisted_20 = {
  key: 0,
  class: "ul2"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  href: "javascript:void(0)"
};
const _hoisted_23 = {
  class: "imgbox"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "innerdetail"
};
const _hoisted_26 = {
  class: "videobox"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  key: 1,
  class: ""
};
const _hoisted_29 = {
  class: "innerbox"
};
const _hoisted_30 = {
  key: 0,
  class: "ul1"
};
const _hoisted_31 = {
  class: "audiobox"
};
const _hoisted_32 = {
  key: 1,
  class: ""
};
const _hoisted_33 = {
  key: 0,
  class: "innerbox"
};
const _hoisted_34 = {
  key: 0,
  class: "type_ul"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  key: 1,
  class: "list"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  key: 1,
  class: "itemInfo"
};
const _hoisted_40 = {
  class: "text-truncate-1"
};
const _hoisted_41 = {
  key: 0,
  class: "itemInfoAuthor"
};
const _hoisted_42 = {
  class: "goodhomework"
};
const _hoisted_43 = {
  key: 0,
  class: "scrollHomework"
};
const _hoisted_44 = {
  class: "top"
};
const _hoisted_45 = ["src"];
const _hoisted_46 = {
  class: "titleinfo"
};
const _hoisted_47 = {
  key: 0,
  class: "title"
};
const _hoisted_48 = {
  key: 1,
  class: "author"
};
const _hoisted_49 = {
  key: 2,
  class: "department"
};
const _hoisted_50 = ["innerHTML"];
const _hoisted_51 = ["innerHTML"];
const _hoisted_52 = {
  key: 2,
  class: "author",
  style: {
    "padding": "0 20px 20px"
  }
};
const _hoisted_53 = ["href"];
const _hoisted_54 = {
  key: 0,
  class: ""
};
const _hoisted_55 = {
  key: 1,
  class: "innerbox"
};
const _hoisted_56 = {
  key: 0,
  class: "type_ul"
};
const _hoisted_57 = ["onClick"];
const _hoisted_58 = {
  key: 1,
  class: "list"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = ["src"];
const _hoisted_61 = {
  key: 1,
  class: "itemInfo"
};
const _hoisted_62 = {
  class: "text-truncate-1"
};
const _hoisted_63 = {
  key: 0,
  class: "itemInfoAuthor"
};
const _hoisted_64 = {
  class: "goodhomework"
};
const _hoisted_65 = {
  key: 0,
  class: "scrollHomework"
};
const _hoisted_66 = {
  class: "top"
};
const _hoisted_67 = ["src"];
const _hoisted_68 = {
  class: "titleinfo"
};
const _hoisted_69 = {
  key: 0,
  class: "title"
};
const _hoisted_70 = {
  key: 1,
  class: "author"
};
const _hoisted_71 = {
  key: 2,
  class: "department"
};
const _hoisted_72 = ["innerHTML"];
const _hoisted_73 = ["innerHTML"];
const _hoisted_74 = {
  key: 2,
  class: "author",
  style: {
    "padding": "0 20px 20px"
  }
};
const _hoisted_75 = ["href"];
const _hoisted_76 = {
  key: 0,
  class: ""
};
const _hoisted_77 = {
  key: 2,
  class: "innerbox"
};
const _hoisted_78 = {
  key: 0,
  class: "list"
};
const _hoisted_79 = ["onClick"];
const _hoisted_80 = ["src"];
const _hoisted_81 = {
  key: 1,
  class: "itemInfo"
};
const _hoisted_82 = {
  class: "text-truncate-1"
};
const _hoisted_83 = {
  key: 0,
  class: "itemInfoAuthor"
};
const _hoisted_84 = {
  class: "goodhomework"
};
const _hoisted_85 = {
  key: 0,
  class: "scrollHomework"
};
const _hoisted_86 = {
  class: "top"
};
const _hoisted_87 = ["src"];
const _hoisted_88 = {
  class: "titleinfo"
};
const _hoisted_89 = {
  key: 0,
  class: "title"
};
const _hoisted_90 = {
  key: 1,
  class: "author"
};
const _hoisted_91 = {
  key: 2,
  class: "department"
};
const _hoisted_92 = ["innerHTML"];
const _hoisted_93 = ["innerHTML"];
const _hoisted_94 = {
  key: 0,
  class: ""
};
const _hoisted_95 = {
  class: "funbox"
};
const _hoisted_96 = {
  key: 0,
  class: "li4"
};
const _hoisted_97 = ["src"];
const _hoisted_98 = {
  key: 1,
  class: "icon-home"
};
const _hoisted_99 = {
  key: 1,
  class: "li2"
};
const _hoisted_100 = ["src"];
const _hoisted_101 = {
  key: 1,
  class: "icon-720"
};
const _hoisted_102 = {
  key: 2,
  class: "li3"
};
const _hoisted_103 = ["src"];
const _hoisted_104 = {
  key: 1,
  class: "icon-topic"
};
const _hoisted_105 = {
  key: 3,
  class: "li1"
};
const _hoisted_106 = {
  key: 4,
  class: "li1"
};
const _hoisted_107 = ["src"];
const _hoisted_108 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_vue_audio = _resolveComponent("vue-audio");
  const _component_Pagination = _resolveComponent("Pagination");
  const _component_Microphone = _resolveComponent("Microphone");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Mute = _resolveComponent("Mute");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_ctx.$attrs.popshowflag && _ctx.$attrs.detail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["popcontainer-style3", ['fid' + _ctx.$route.query.fid, {
      mobile: _ctx.$attrs.isMobile
    }, {
      useSvw: _ctx.$attrs.id === 1
    }]])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$attrs.detail.place_name), 1), _createElementVNode("div", _hoisted_4, [_cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "eye"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.view ? _ctx.$attrs.detail.view : 0), 1)])]), _createElementVNode("div", {
    class: "closediv",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closePop && $options.closePop(...args))
  }, _cache[11] || (_cache[11] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)]))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popLeftArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass([{
        active: $data.popLeftIndex === item.id
      }, "leftselect"]),
      key: index,
      onClick: $event => $options.popLeftHandle(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_7);
  }), 128))])]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-container swiperbox visibleitem", {
      on: _ctx.$attrs.detail.currentShowtype === 'banner'
    }]),
    ref: "swipercontainer"
  }, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.banner, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl)
    }, null, 8, _hoisted_12), _createElementVNode("h4", null, [_createElementVNode("span", null, _toDisplayString(i + 1), 1), _cache[12] || (_cache[12] = _createTextVNode("/")), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.banner.length), 1)])]);
  }), 128))])], 2)], 512), [[_vShow, _ctx.$attrs.detail.banner && _ctx.$attrs.detail.banner.length > 0]]), _cache[15] || (_cache[15] = _createElementVNode("div", {
    class: "intropic"
  }, null, -1)), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    class: "infodesc",
    innerHTML: $options.replaceIframeSrc(_ctx.$attrs.detail.introduce)
  }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_ctx.$attrs.detail.telphone !== undefined && _ctx.$attrs.detail.telphone !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_16, [_createElementVNode("a", {
    href: `tel:${_ctx.$attrs.detail.telphone}`
  }, [_cache[13] || (_cache[13] = _createElementVNode("span", {
    class: "icon-tel"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.telphone), 1)], 8, _hoisted_17)])) : _createCommentVNode("", true), _ctx.$attrs.detail.route && _ctx.$attrs.detail.route.length > 0 && Object.keys(_ctx.$attrs.detail.route[0]).length > 1 ? (_openBlock(), _createElementBlock("p", _hoisted_18, [_cache[14] || (_cache[14] = _createElementVNode("span", {
    class: "icon-location1"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($options.getAddress(_ctx.$attrs.detail.route)), 1)])) : _createCommentVNode("", true)])], 512), [[_vShow, $data.popLeftIndex === 0]]), _withDirectives(_createElementVNode("div", _hoisted_19, [_ctx.$attrs.detail.video !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.video, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.videoItemHandle(item)
    }, [_createElementVNode("a", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl),
      alt: ""
    }, null, 8, _hoisted_24)]), _createElementVNode("h2", null, _toDisplayString(item.title), 1)])], 8, _hoisted_21);
  }), 128))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_25, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.closevideoItem && $options.closevideoItem(...args))
  }, _cache[16] || (_cache[16] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)])), _createElementVNode("h2", null, _toDisplayString($data.videoitem.title), 1), _createElementVNode("div", _hoisted_26, [_createElementVNode("video", {
    src: $data.videoitem.url,
    controls: ""
  }, null, 8, _hoisted_27)])], 512), [[_vShow, $data.videoitemflag && $data.videoitem !== '']]), _ctx.$attrs.detail.video === '' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 2]]), _withDirectives(_createElementVNode("div", _hoisted_29, [_ctx.$attrs.detail.audio !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.audio, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createElementVNode("h2", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_31, [_createVNode(_component_vue_audio, {
      file: item.url
    }, null, 8, ["file"])])]);
  }), 128))])) : _createCommentVNode("", true), _ctx.$attrs.detail.audio === '' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 3]]), $data.popLeftIndex === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["goodhomeworklist", {
      'height100': $data.xyjjList.length != 0
    }])
  }, [$data.xyjjType.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.xyjjType, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.typeIndex === index
      }),
      onClick: $event => $options.typeClick(item, index),
      key: index
    }, _toDisplayString(item.title), 11, _hoisted_35);
  }), 128))])) : _createCommentVNode("", true), $data.xyjjTotal != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.xyjjList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index,
      onClick: $event => $options.toDetail(item.itemformdata)
    }, [item.itemformdata.xy_cover && item.itemformdata.xy_cover.length > 0 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "itemPic",
      src: item.itemformdata.xy_cover[0].fileUrl
    }, null, 8, _hoisted_38)) : _createCommentVNode("", true), item.itemformdata.xy_title ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, _toDisplayString(item.itemformdata.xy_title), 1), item.itemformdata.xy_author ? (_openBlock(), _createElementBlock("span", _hoisted_41, " 作者：" + _toDisplayString(item.itemformdata.xy_author), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 8, _hoisted_37);
  }), 128))])) : _createCommentVNode("", true), $data.xyjjList.length != 0 ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 2,
    class: "page",
    "total-pages": $data.xyjjTotal,
    "current-page": $data.currentPage,
    onPageChange: $options.handlePageChange
  }, null, 8, ["total-pages", "current-page", "onPageChange"])) : _createCommentVNode("", true)], 2), [[_vShow, !$data.showGood]]), _withDirectives(_createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
    class: "homeback",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.homeback && $options.homeback(...args))
  }), $data.currentItem !== null ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [$data.currentItem.xy_cover && $data.currentItem.xy_cover.length > 0 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "toppic",
    src: $data.currentItem.xy_cover[0].fileUrl
  }, null, 8, _hoisted_45)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_46, [$data.currentItem.xy_title ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_cache[17] || (_cache[17] = _createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1)), _createTextVNode(" " + _toDisplayString($data.currentItem.xy_title) + " ", 1), _cache[18] || (_cache[18] = _createElementVNode("div", {
    class: "titlebar1"
  }, null, -1)), _cache[19] || (_cache[19] = _createElementVNode("div", {
    class: "titlebar2"
  }, null, -1))])) : _createCommentVNode("", true), $data.currentItem.xy_author ? (_openBlock(), _createElementBlock("div", _hoisted_48, " 作者姓名：" + _toDisplayString($data.currentItem.xy_author), 1)) : _createCommentVNode("", true), $data.currentItem.department ? (_openBlock(), _createElementBlock("div", _hoisted_49, "作者单位：" + _toDisplayString($data.currentItem.department), 1)) : _createCommentVNode("", true)])]), $data.currentItem.xy_content ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "homeworkcontent",
    innerHTML: $data.currentItem.xy_content
  }, null, 8, _hoisted_50)) : $data.currentItem.xy_introduction ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "homeworkcontent",
    innerHTML: $data.currentItem.xy_introduction
  }, null, 8, _hoisted_51)) : _createCommentVNode("", true), $data.currentItem.xy_link ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("a", {
    href: $data.currentItem.xy_link,
    target: "_blank"
  }, "查看链接", 8, _hoisted_53)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512), [[_vShow, $data.showGood && $data.xyjjList.length !== 0]]), $data.xyjjList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.popLeftIndex === 5 ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["goodhomeworklist", {
      'height100': $data.zytjList.length != 0
    }])
  }, [$data.zytjType.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_56, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.zytjType, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.typeIndex === index
      }),
      onClick: $event => $options.typeClick(item, index),
      key: index
    }, _toDisplayString(item.title), 11, _hoisted_57);
  }), 128))])) : _createCommentVNode("", true), $data.zytjTotal != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_58, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.zytjList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index,
      onClick: $event => $options.toDetail(item.itemformdata)
    }, [item.itemformdata.zy_cover && item.itemformdata.zy_cover.length > 0 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "itemPic",
      src: item.itemformdata.zy_cover[0].fileUrl
    }, null, 8, _hoisted_60)) : _createCommentVNode("", true), item.itemformdata.zy_title ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(item.itemformdata.zy_title), 1), item.itemformdata.zy_author ? (_openBlock(), _createElementBlock("span", _hoisted_63, " 作者：" + _toDisplayString(item.itemformdata.zy_author), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 8, _hoisted_59);
  }), 128))])) : _createCommentVNode("", true), $data.zytjList.length != 0 ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 2,
    class: "page",
    "total-pages": $data.zytjTotal,
    "current-page": $data.currentPage,
    onPageChange: $options.handlePageChange
  }, null, 8, ["total-pages", "current-page", "onPageChange"])) : _createCommentVNode("", true)], 2), [[_vShow, !$data.showGood]]), _withDirectives(_createElementVNode("div", _hoisted_64, [_createElementVNode("div", {
    class: "homeback",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.homeback && $options.homeback(...args))
  }), $data.currentItem !== null ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [$data.currentItem.zy_cover && $data.currentItem.zy_cover.length > 0 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "toppic",
    src: $data.currentItem.zy_cover[0].fileUrl
  }, null, 8, _hoisted_67)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_68, [$data.currentItem.zy_title ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_cache[20] || (_cache[20] = _createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1)), _createTextVNode(" " + _toDisplayString($data.currentItem.zy_title) + " ", 1), _cache[21] || (_cache[21] = _createElementVNode("div", {
    class: "titlebar1"
  }, null, -1)), _cache[22] || (_cache[22] = _createElementVNode("div", {
    class: "titlebar2"
  }, null, -1))])) : _createCommentVNode("", true), $data.currentItem.zy_author ? (_openBlock(), _createElementBlock("div", _hoisted_70, " 作者姓名：" + _toDisplayString($data.currentItem.zy_author), 1)) : _createCommentVNode("", true), $data.currentItem.department ? (_openBlock(), _createElementBlock("div", _hoisted_71, "作者单位：" + _toDisplayString($data.currentItem.department), 1)) : _createCommentVNode("", true)])]), $data.currentItem.zy_content ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "homeworkcontent",
    innerHTML: $data.currentItem.zy_content
  }, null, 8, _hoisted_72)) : $data.currentItem.zy_introduction ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "homeworkcontent",
    innerHTML: $data.currentItem.zy_introduction
  }, null, 8, _hoisted_73)) : _createCommentVNode("", true), $data.currentItem.zy_link ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_createElementVNode("a", {
    href: $data.currentItem.zy_link,
    target: "_blank"
  }, "查看链接", 8, _hoisted_75)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512), [[_vShow, $data.showGood && $data.zytjList.length !== 0]]), $data.zytjList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_76, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.popLeftIndex === 6 ? (_openBlock(), _createElementBlock("div", _hoisted_77, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["goodhomeworklist", {
      'height100': $data.xsyxzpList.length != 0
    }])
  }, [$data.xsyxzpTotal != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_78, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.xsyxzpList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index,
      onClick: $event => $options.toDetail(item.itemformdata)
    }, [item.itemformdata.yxzp_cover && item.itemformdata.yxzp_cover.length > 0 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "itemPic",
      src: item.itemformdata.yxzp_cover[0].fileUrl
    }, null, 8, _hoisted_80)) : _createCommentVNode("", true), item.itemformdata.yxzp_title ? (_openBlock(), _createElementBlock("div", _hoisted_81, [_createElementVNode("span", _hoisted_82, _toDisplayString(item.itemformdata.yxzp_title), 1), item.itemformdata.yxzp_author ? (_openBlock(), _createElementBlock("span", _hoisted_83, " 作者：" + _toDisplayString(item.itemformdata.yxzp_author), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 8, _hoisted_79);
  }), 128))])) : _createCommentVNode("", true), $data.xsyxzpList.length != 0 ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 1,
    class: "page",
    "total-pages": $data.xsyxzpTotal,
    "current-page": $data.currentPage,
    onPageChange: $options.handlePageChange
  }, null, 8, ["total-pages", "current-page", "onPageChange"])) : _createCommentVNode("", true)], 2), [[_vShow, !$data.showGood]]), _withDirectives(_createElementVNode("div", _hoisted_84, [_createElementVNode("div", {
    class: "homeback",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.homeback && $options.homeback(...args))
  }), $data.currentItem !== null ? (_openBlock(), _createElementBlock("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [$data.currentItem.yxzp_cover && $data.currentItem.yxzp_cover.length > 0 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "toppic",
    src: $data.currentItem.yxzp_cover[0].fileUrl
  }, null, 8, _hoisted_87)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_88, [$data.currentItem.yxzp_title ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_cache[23] || (_cache[23] = _createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1)), _createTextVNode(" " + _toDisplayString($data.currentItem.yxzp_title) + " ", 1), _cache[24] || (_cache[24] = _createElementVNode("div", {
    class: "titlebar1"
  }, null, -1)), _cache[25] || (_cache[25] = _createElementVNode("div", {
    class: "titlebar2"
  }, null, -1))])) : _createCommentVNode("", true), $data.currentItem.yxzp_author ? (_openBlock(), _createElementBlock("div", _hoisted_90, "作者姓名：" + _toDisplayString($data.currentItem.yxzp_author), 1)) : _createCommentVNode("", true), $data.currentItem.department ? (_openBlock(), _createElementBlock("div", _hoisted_91, "作者单位：" + _toDisplayString($data.currentItem.department), 1)) : _createCommentVNode("", true)])]), $data.currentItem.yxzp_content ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "homeworkcontent",
    innerHTML: $data.currentItem.yxzp_content
  }, null, 8, _hoisted_92)) : $data.currentItem.yxzp_introduction ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "homeworkcontent",
    innerHTML: $data.currentItem.yxzp_introduction
  }, null, 8, _hoisted_93)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512), [[_vShow, $data.showGood && $data.xsyxzpList.length !== 0]]), $data.xsyxzpList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_94, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createElementVNode("ul", _hoisted_95, [_ctx.$attrs.detail.portal_link ? (_openBlock(), _createElementBlock("li", _hoisted_96, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => $options.goLink(_ctx.$attrs.detail.portal_link)),
    target: "_blank"
  }, [$data.structImgdefaultValues.linkpic1 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.structImgdefaultValues.linkpic1,
    alt: ""
  }, null, 8, _hoisted_97)) : (_openBlock(), _createElementBlock("span", _hoisted_98)), _createTextVNode(" " + _toDisplayString($data.structLabel.portal_link), 1)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.virtual_link ? (_openBlock(), _createElementBlock("li", _hoisted_99, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = $event => $options.goLink(_ctx.$attrs.detail.virtual_link)),
    target: "_blank"
  }, [$data.structImgdefaultValues.linkpic2 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.structImgdefaultValues.linkpic2,
    alt: ""
  }, null, 8, _hoisted_100)) : (_openBlock(), _createElementBlock("span", _hoisted_101)), _createTextVNode(" " + _toDisplayString($data.structLabel.virtual_link), 1)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.special_link ? (_openBlock(), _createElementBlock("li", _hoisted_102, [_createElementVNode("a", {
    onClick: _cache[7] || (_cache[7] = $event => $options.goLink(_ctx.$attrs.detail.special_link)),
    target: "_blank"
  }, [$data.structImgdefaultValues.linkpic3 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.structImgdefaultValues.linkpic3,
    alt: ""
  }, null, 8, _hoisted_103)) : (_openBlock(), _createElementBlock("span", _hoisted_104)), _createTextVNode(" " + _toDisplayString($data.structLabel.special_link), 1)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.route.length > 0 && _ctx.$attrs.detail.route[0].lng && $data.daohangflag ? (_openBlock(), _createElementBlock("li", _hoisted_105, [_createElementVNode("a", {
    onClick: _cache[8] || (_cache[8] = $event => $options.goLocation(_ctx.$attrs.detail)),
    target: "_blank"
  }, _cache[26] || (_cache[26] = [_createElementVNode("span", {
    class: "icon-location"
  }, null, -1), _createTextVNode("导航")]))])) : _createCommentVNode("", true), _ctx.$attrs.detail.audiodesc && _ctx.$attrs.detail.audiodesc.length > 0 ? (_openBlock(), _createElementBlock("li", _hoisted_106, [_createElementVNode("a", {
    onClick: _cache[9] || (_cache[9] = (...args) => $options.playaudiodesc && $options.playaudiodesc(...args)),
    target: "_blank"
  }, [_withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Microphone)]),
    _: 1
  }, 512), [[_vShow, !$data.audiodescflag]]), _withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Mute)]),
    _: 1
  }, 512), [[_vShow, $data.audiodescflag]]), _cache[27] || (_cache[27] = _createTextVNode("语音"))]), _createElementVNode("audio", {
    ref: "audiodesc",
    id: "audiodesc",
    style: {
      "width": "0",
      "height": "0"
    },
    autoplay: "",
    src: _ctx.$attrs.detail.audiodesc[0].url
  }, null, 8, _hoisted_107)])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_108), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("返回")])),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]])]);
}